import { COUNTRIES_LIST } from "../constants/globalConstants";

export const getAlpha2CodeForCountry = (country: string) => {
  return COUNTRIES_LIST.find(
    (c: any) => c.value === country
  )?.code.toLowerCase();
};
